/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./OrgSetupBank.css";
import { useStripe, useElements } from "@stripe/react-stripe-js";
import PropTypes from "prop-types";
import { simpleFetch } from "../../../restWrapper";
import { renderErrorMsg } from "../../../assets/component/renderErrorMsg.js";
import { getStripeErrorMessage } from "../../../assets/errorMessages.js";
import Promise from "bluebird";
import { PLATFORM } from "../../../config";

class AddBankForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      clearingCode: "",
      branchCode: "",
      isDefault: false,
      language: this.props.language,
      bankList: this.props.languageObj.bankList,
      languageObj: this.props.languageObj,
      selectedBank: "",
      acNo: "",
      accountHolderName: "",
      errMsg: {
        clearingCode: "",
        branchCode: "",
        acNo: "",
        accountHolderName: "",
        btn: "",
      },
    };
    this.submitBtn = this.submitBtn.bind(this);

    this.handleClearingCode = this.handleInput.bind(this, "clearingCode");
    this.handleBranchCode = this.handleInput.bind(this, "branchCode");
    this.handleAcNo = this.handleInput.bind(this, "acNo");
    this.handleAccountHolderName = this.handleInput.bind(this, "accountHolderName");
    this.handleSelectBox = this.handleSelectBox.bind(this);

    this.setDefaultBtn = this.setDefaultBtn.bind(this);
  }

  componentDidMount() {
    this.setState({
      loading: true,
    });
    simpleFetch("/organizations", "GET", {}).then((res) => {
      this.setState({
        loading: false,
      });

      if (!res.body.organizationObj.organizationName) {
        this.props.history.push({ pathname: "/OrgSettings", page: 4 });
      }

      // Get the organization type
      const organizationType =
        res.body.organizationObj.organizationType || "nonprofit";
      // console.log("AddBankForm: Using organization type:", organizationType);

      this.setState({
        organizationName: res.body.organizationObj.organizationName,
        accountHolderName: res.body.organizationObj.organizationName,
        organizationType: organizationType,
      });
    });
  }

  handleInput(name, e) {
    let s = e.target.value;
    if (name === "branchCode") {
      if (s.length > 3) return false;
    }
    let data = this.state;
    data[name] = s;
    data.errMsg[name] = "";
    this.setState({
      data,
    });
  }

  handleSelectBox(e) {
    let v = e.target.value;
    let state = this.state;
    state.errMsg["clearingCode"] = "";
    state.selectedBank = e.target.value;
    if (v !== null && v !== "other") {
      state.clearingCode = e.target.value;
    } else {
      state.clearingCode = "";
    }
    this.setState({
      state,
    });
  }

  getBankList() {
    return simpleFetch("/organizations/banks", "GET").then((res) => {
      return res;
    });
  }

  getStripeToken(ev) {
    ev.preventDefault();
    const routing_number =
      this.state.clearingCode + "-" + this.state.branchCode;
    return this.props.stripe
      .createToken("bank_account", {
        country: "HK",
        currency: "hkd",
        account_holder_name: this.state.accountHolderName,
        account_holder_type: "company",
        routing_number: routing_number,
        account_number: this.state.acNo,
        object: "bank_account",
      })
      .then(({ token, error }) => {
        // Return both token and error so caller can handle appropriately
        return { token, error };
      });
  }

  deleteOldAc(bankId) {
    if (!bankId) return false;
    // Pass the organization type as a query parameter
    const organizationType = this.state.organizationType || "nonprofit";
    simpleFetch(
      `/organizations/banks/${bankId}?organizationType=${organizationType}`,
      "DELETE",
    );
  }

  createNewAc(token) {
    // Pass the organization type as a query parameter
    const organizationType = this.state.organizationType || "nonprofit";
    return simpleFetch(
      `/organizations/banks?organizationType=${organizationType}`,
      "POST",
      {
        sourceToken: token.id,
        default_for_currency: true,
      },
    ).then((res) => {
      return res;
    });
  }

  submitBtn(ev) {
    if (this.state.loading) return false;
    // check input data
    if (
      !this.state.clearingCode ||
      !this.state.branchCode ||
      !this.state.acNo ||
      !this.state.accountHolderName
    ) {
      // if error ,show err msg and return
      var err = {
        clearingCodeSelect: "請選擇銀行",
        clearingCodeInput: "請輸入銀行 Clearing Code",
        branchCode: "請輸入分行號碼(Branch Code)",
        acNo: "請輸入戶口號碼",
        accountHolderName: "請輸入戶口持有人名稱（英文）",
      };
      let ccErr;
      let bcErr;
      let anErr;
      let ahnErr;

      if (!this.state.clearingCode) {
        if (this.state.selectedBank === "other") {
          ccErr = err.clearingCodeInput;
        } else {
          ccErr = err.clearingCodeSelect;
        }
      }

      if (!this.state.branchCode) {
        bcErr = err.branchCode;
      }

      if (!this.state.acNo) {
        anErr = err.acNo;
      }

      if (!this.state.accountHolderName) {
        ahnErr = err.accountHolderName;
      }

      let errMsg = this.state.errMsg;

      errMsg.clearingCode = !ccErr ? "" : ccErr;
      errMsg.branchCode = !bcErr ? "" : bcErr;
      errMsg.acNo = !anErr ? "" : anErr;
      errMsg.accountHolderName = !ahnErr ? "" : ahnErr;
      this.setState({
        errMsg: errMsg,
      });
      return false;
    }
    let errMsg = this.state.errMsg;

    errMsg.clearingCode = "";
    errMsg.branchCode = "";
    errMsg.acNo = "";
    errMsg.accountHolderName = "";

    this.setState({
      errMsg: errMsg,
    });

    this.setState({
      loading: true,
    });

    Promise.all([this.getBankList(), this.getStripeToken(ev)]).then((res) => {
      const bankData = res[0];
      const stripeResult = res[1];
      const token = stripeResult?.token;
      const stripeError = stripeResult?.error;

      // Check for Stripe token creation error first
      if (stripeError) {
        // Use the error message utility to get a user-friendly message
        const errorMessage = getStripeErrorMessage(stripeError, "zh");
        errMsg.btn = errorMessage;
        this.setState({
          errMsg: errMsg,
          loading: false,
        });
        return false;
      }

      // check stripe token
      if (token) {
        //create bank ac
        // Pass the organization type as a query parameter
        const organizationType = this.state.organizationType || "nonprofit";
        const createAc = simpleFetch(
          `/organizations/banks?organizationType=${organizationType}`,
          "POST",
          {
            sourceToken: token.id,
            default_for_currency: true,
          },
        );
        createAc.then((res) => {
          //check any bank ac is/are saved
          if (res.status !== 200) {
            //Fail
            err = "未能完成，請稍候再試";
            if (res.body.message) {
              err = res.body.message;
            }

            // error code
            errMsg.btn = !err ? "" : err;

            this.setState({
              errMsg: errMsg,
              loading: false,
            });
            return false;
          } else {
            if (bankData.body.length > 0) {
              let oldAc = [];
              //delete all old ac
              for (var i = 0; i < bankData.body.length; i++) {
                oldAc[i] = this.deleteOldAc(bankData.body[i].id);
              }
              Promise.all(oldAc).finally((res) => {
                //all deleted
              });
            }
            this.props.nextBtn();
          }
        });
      } else {
        // No token and no error - unexpected state
        err = "未能完成，請稍候再試";
        errMsg.btn = err;
        this.setState({
          errMsg: errMsg,
          loading: false,
        });
      }
    });
  }

  setDefaultBtn(e) {
    let bool = !this.state.isDefault;
    this.setState({
      isDefault: bool,
    });
  }

  renderStatusBtn() {
    const defaultColor = this.state.isDefault
      ? { color: "#000" }
      : { background: "#E3E3E3" };
    return (
      <div
        className="OrgSetupBank-defaultBtn"
        style={defaultColor}
        onClick={this.setDefaultBtn}
      ></div>
    );
  }
  renderCCInput(textObj) {
    if (this.state.selectedBank !== "other") return;
    return (
      <div>
        <div className="OrgSetupBank-inputFieldContainer">
          <input
            type="text"
            className="OrgSetupBank-inputField"
            value={this.state.clearingCode}
            onChange={this.handleClearingCode}
            placeholder={textObj.inputField}
          />
          {renderErrorMsg(this.state.errMsg.clearingCode)}
        </div>
        <div className="OrgSetupBank-subheading">
          <a
            style={{ color: "#2482C4" }}
            rel="noopener noreferrer"
            href="https://www.hkicl.com.hk/eng/information_centre/clearing_code_and_branch_code_list.php"
            target="_blank"
          >
            {textObj.subheading}
          </a>
        </div>
      </div>
    );
  }

  render() {
    if (this.state.loading) {
      return <this.props.RenderFullPageLoading />;
    }

    const languageObj = this.state.languageObj;

    const isFormValid =
      !!this.state.clearingCode &&
      !!this.state.branchCode &&
      !!this.state.acNo &&
      !!this.state.accountHolderName;

    const onSubmitClick = (ev) => {
      if (!isFormValid) return;
      this.submitBtn(ev);
    };

    return (
      <div className="OrgSetupBank-view">
        <div className="OrgSetupBank-center">
          <div className="OrgSetupBank-header">
            {/* Conditionally render logo based on platform */}
            <div
              className={
                PLATFORM === "plug"
                  ? "OrgSetupBank-PlugLogo"
                  : "OrgSetupBank-CheckPlusLogo"
              }
            />

            <div className="OrgSetupBank-headerBottom">
              <div
                className="OrgSetupBank-backBtn"
                onClick={this.props.backBtn}
              >
                <div className="OrgSetupBank-backIcn" />
              </div>

              <div className="OrgSetupBank-steps">{languageObj.step}</div>
            </div>
          </div>

          <div className="OrgSetupBank-subheading">
            {languageObj.subheading[1]}
          </div>
          <div className="OrgSetupBank-inputFieldContainer">
            <select
              className="OrgSetupBank-inputField"
              value={this.state.selectedBank}
              onChange={this.handleSelectBox}
            >
              {this.state.bankList.map((bank) => (
                <option key={bank[1] + bank[0]} value={bank[1]}>
                  {bank[0]}
                </option>
              ))}
            </select>
            {renderErrorMsg(
              this.state.selectedBank !== "other"
                ? this.state.errMsg.clearingCode
                : "",
            )}
          </div>

          {this.renderCCInput(languageObj.CCInput)}

          <div className="OrgSetupBank-subheading">
            {languageObj.subheading[2]}
          </div>
          <div className="OrgSetupBank-inputFieldContainer">
            <input
              type="text"
              className="OrgSetupBank-inputField"
              value={this.state.branchCode}
              onChange={this.handleBranchCode}
              placeholder={languageObj.inputField[0]}
            />
            {renderErrorMsg(this.state.errMsg.branchCode)}
          </div>

          <div className="OrgSetupBank-subheading">
            {languageObj.subheading[3]}
          </div>
          <div className="OrgSetupBank-inputFieldContainer">
            <input
              type="text"
              className="OrgSetupBank-inputField"
              value={this.state.acNo}
              onChange={this.handleAcNo}
              placeholder={languageObj.inputField[1]}
            />
            {renderErrorMsg(this.state.errMsg.acNo)}
          </div>

          <div className="OrgSetupBank-subheading">
            {languageObj.subheading[4]}
          </div>
          <div className="OrgSetupBank-inputFieldContainer">
            <input
              type="text"
              className="OrgSetupBank-inputField"
              value={this.state.accountHolderName}
              onChange={this.handleAccountHolderName}
              placeholder={languageObj.inputField[2]}
            />
            {renderErrorMsg(this.state.errMsg.accountHolderName)}
          </div>

          <div
            className="OrgSetupBank-logoutTxt"
            onClick={this.props.orgLogout}
          >
            {languageObj.rightBtn}
          </div>

          {/* CP-304: allow skipping bank setup so profile/impact work is not
              blocked. Setup remains resumable from OrgSetup later. */}
          <div
            className="OrgSetupBank-logoutTxt"
            onClick={this.props.skipPaymentsBtn || this.props.nextBtn}
            style={{ marginTop: 8, cursor: "pointer" }}
          >
            {(languageObj && languageObj.setupPaymentsLater) ||
              "Set up payments later"}
          </div>

          <div
            className={"OrgSetupBank-nextBtn" + (isFormValid ? "" : " OrgSetupBank-nextBtn-disabled")}
            aria-disabled={!isFormValid}
            onClick={onSubmitClick}
          >
            <div className="OrgSetupBank-nextIcnContainer">
              <div className="OrgSetupBank-nextIcn" />
            </div>

            <div className="OrgSetupBank-nextText">{languageObj.submitBtn}</div>
          </div>

          {renderErrorMsg(this.state.errMsg.btn)}
        </div>
      </div>
    );
  }
}

AddBankForm.propTypes = {
  stripe: PropTypes.object.isRequired,
  isOrgAuth: PropTypes.bool,
  language: PropTypes.string,
  languageObj: PropTypes.object,
  RenderFullPageLoading: PropTypes.func,
  backBtn: PropTypes.func,
  nextBtn: PropTypes.func,
  skipPaymentsBtn: PropTypes.func,
  orgLogout: PropTypes.func,
};

// Wrapper component to use Stripe hooks with class component
function AddBankFormWithStripe(props) {
  const stripe = useStripe();
  const elements = useElements();

  return <AddBankForm {...props} stripe={stripe} elements={elements} />;
}

export default AddBankFormWithStripe;
